import request from '@/utils/request'

// 创建发票信息
export function createInvoiceInfo(data) {
  return request({
    url: `/invoice_infos`,
    method: 'post',
    data
  })
}

// 查询发票信息
export function findInvoiceInfos(params) {
  return request({
    url: `/invoice_infos`,
    method: 'get',
    params: params
  })
}

